import { QueryFilters } from '@tanstack/react-query';
import { DashboardItemDto } from '@unistocks/proxy/axios-client';
import { savingsGoalsGetQueryKey } from '@unistocks/proxy/axios-client/SavingsGoalsQuery';

export const queryFilter = ({ settings }: DashboardItemDto): QueryFilters | null =>
  settings.savingsGoal ? { queryKey: savingsGoalsGetQueryKey(settings.savingsGoal) } : null;
